import Grants from './grants';

const grantsRoutes = [
  { path: 'grants', element: <Grants /> },
  { path: 'apoios', element: <Grants /> },
];

export default grantsRoutes;
